import {CompanyReportScreen} from "./ProductsReports.jsx";
export default function CRMReports(){return <CompanyReportScreen kind="crm"/>;}
